import ApiClient from './ApiClient';

// Read-only access to the account's AI Field Fill trigger settings
// (on_transfer / on_resolution / manual_enabled). Singular resource, so the
// inherited `get()` hits `/api/v1/accounts/:id/ai_field_fill_settings` — using
// ApiClient's global (auth-configured) axios, not a bare import.
class AiFieldFillSettingsAPI extends ApiClient {
  constructor() {
    super('ai_field_fill_settings', { accountScoped: true });
  }
}

export default new AiFieldFillSettingsAPI();
